<template>
  <!-- <div class="card sidebar">
    <div class="card-body widget cardbodych" style="">
      <h5
        class=""
        style="
                  font-style: normal;
                  font-weight: 700 !important;
                  font-size: 30px;
                  line-height: 120%;
                  color: #005696;
                "
      >
        Getting ready for <br /
        a new venture?
      </h5>
    </div>
    <div class="col-12">
      <p
        style="
                  font-style: normal;
                  font-weight: 400;
                  font-size: 18px;
                  line-height: 140%;
                  color: #666666;
                  background: transparent !important;
                "
      >
        Watch product features, news, updates on our youtube channel to be
        updated.
      </p>
      <button
        style="
                  padding: 12px 16px;
                  gap: 8px;
                  background: #35a2e5;
                  border-radius: 53px;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 140%;
                  color: #ffffff;
                "
      >
        Contact Sales
        <img
          class="dashbord"
          src="\images/job_application/Call.svg"
          alt=""
          style="margin-left: 10px"
        />
      </button>
    </div>
  </div> -->
  <div class="col-lg-12 p-0 alwyes">
    <div class="col-lg-12 pl-0 pr-0 pt-4">
      <div class="card sidebar">
        <div class="card-body widget cardbodych" style="">
          <h5
            class=""
            style="
                        font-style: normal;
                        font-weight: 700 !important;
                        font-size: 30px;
                        line-height: 120%;
                        color: #005696;
                      "
          >
          Advertise with  <br />
          job4u.pk
          </h5>
        </div>
        <div class="col-12">
          <p
            style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 140%;
                        color: #666666;
                        background: transparent !important;
                      "
          >
          Contact us to display your
          Ad here to reach tens of
          thousands of people!

          </p>
          <button
            style="
                        padding: 12px 16px;
                        gap: 8px;
                        background: #35a2e5;
                        border-radius: 53px;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 16px;
                        line-height: 140%;
                        color: #ffffff;
                      "
          >
          <img
              class="dashbord123"
              src="\images/job_application/Call.svg"
              alt=""
              style="margin-right: 10px"
            />
              Contact Sales
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  setup() {},
});
</script>
